import axios from '../../axios'
export default {
  /**
   * 自定义专题
   */
  querySeminar: (spId: string) => {
    return axios.get('/learn/app/clientapi/home/secondPage.do', {
      params: {
        spId,
      },
    })
  },
}
